import { useEffect } from 'react';

import MapSideNavigation from '@atom/components/common/map/mapSideNavigation/MapSideNavigation';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';

const MapPortalSideNavigation = () => {
  const [{ view: navigation }, { updateSearchParams }] = useNavigation({
    view: SearchParamType.STRING,
  });

  useEffect(() => {
    if (!navigation) {
      updateSearchParams({ view: 'layers' });
    }
  }, [navigation]);

  const handleNavigate = (newView: string) => {
    updateSearchParams({ view: newView });
  };

  return (
    <MapSideNavigation
      activeNavigationState={navigation}
      onNavigation={handleNavigate}
    />
  );
};

export default MapPortalSideNavigation;
